import Vue from "vue";

import dialog from '@/components/dialog';
import UploadImg from '@/components/UploadImg';
import selectCraft from '@/components/selectcraft';
import imgView from '@/components/imgView';
import tableColumn from '@/components/table-column';
import telInput from '@/components/telInput';
import selectAddressCascader from '@/components/selectAddressCascader.vue';

Vue.component("re-dialog", dialog);
Vue.component("select-craft", selectCraft);
Vue.component("img-view", imgView);
Vue.component("upload-img", UploadImg);
Vue.component("table-column", tableColumn);
Vue.component("tel-input", telInput);
Vue.component("select-address-cascader", selectAddressCascader);


// WEBPACK FOOTER //
// ./src/globalComponents.js